import script from "./TreeAccordion.vue?vue&type=script&setup=true&lang=js"
export * from "./TreeAccordion.vue?vue&type=script&setup=true&lang=js"

import "./TreeAccordion.vue?vue&type=style&index=0&id=1d9cf7ae&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d9cf7ae"]])

export default __exports__